// @flow

import React from 'react';
import styled from 'styled-components';
import type { Theme } from '../../../types';
import { SortDropdownContainer } from './sortDropdown';

const Container = styled<any, Theme>('div')`
  height: 4.35rem;
  background-color: ${props => props.theme.assortment.filterBar.backgroundColor};
  display: flex;
  align-items: center;
  flex-direction: row;
  padding-right: 1rem;
  padding-left: 1rem;
  border-radius: 4px;
  margin-bottom: 1rem;
  justify-content: flex-end;
`;

const FilterBar = () => (
  <Container>
    <SortDropdownContainer />
  </Container>
);

export default FilterBar;
